import { render, staticRenderFns } from "./proceso_envio.vue?vue&type=template&id=81c518c6&scoped=true&"
import script from "./proceso_envio.vue?vue&type=script&lang=ts&"
export * from "./proceso_envio.vue?vue&type=script&lang=ts&"
import style0 from "./proceso_envio.vue?vue&type=style&index=0&id=81c518c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c518c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
